import { useTask } from 'domain/swr';
import { useParams } from 'react-router-dom';

export const useExecutionId = () => {
  const { id } = useParams();
  const { task, } = useTask(id ?? '');
  const executionId = task?.process_id;
  return { id, executionId };
};
